import { lazy } from 'react';

const EnergyTools = lazy(() => import('./page'));

export default EnergyTools;
